import React from 'react';
import ContentComponent from './content.component';

function Content() {
    return <ContentComponent />;
}

export default Content;
